import script from "./login-container.vue?vue&type=script&setup=true&lang=js"
export * from "./login-container.vue?vue&type=script&setup=true&lang=js"

import "./login-container.vue?vue&type=style&index=0&id=947528fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaole\\Documents\\work\\dc\\www.tzspace.cn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-947528fa"]])

export default __exports__